// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"bf44ffe1","169":"4e0e10eb","460":"7e4f03a7","509":"bec52566","583":"d3f74d2e","679":"de49706e","855":"540426c1","896":"b2f93c9a","935":"23d8d6fc"}[chunkId] + ".chunk.js";
};